import React from "react";
import { Modal, Card } from "react-bootstrap";

const TabLeave = ({ show, closePopup, handleYes, handleNo }) => {
  return (
    <Modal
      show={show}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      dialogClassName="docg-modal"
      size="sm"
      centered
    >
      <Card>
        <Card.Body className="d-flex flex-column align-items-center justify-content-center">
          <span>Do you want to save changes?</span>
          <div className="d-flex mt-3">
            <button onClick={handleNo} className="docg-save-btn bg-purple mr-2">
              Yes
            </button>
            <button onClick={handleYes} className="docg-save-btn">
              No
            </button>
          </div>
        </Card.Body>
      </Card>
    </Modal>
  );
};

export default TabLeave;
